// File: src/components/impact/ImpactInfographic.js

import React from 'react';
import styles from './ImpactInfographic.module.css';
import ScrollAnimation from '../common/ScrollAnimation';
import { cn } from '../../utils/helpers';

function ImpactInfographic() {
  return (
    <section className={styles.section}>
      <div className={cn('site-container', styles.inner)}>

        {/* Section header */}
        <ScrollAnimation className={styles.header}>
          <p className={styles.eyebrow}>Ten Wins, No Losses</p>
          <h2 className={styles.heading}>
            The GreenScience Soil Revolution
          </h2>
          <p className={styles.subheading}>
            Our process doesn't just solve one problem — it creates ten distinct
            wins across environmental stewardship, community infrastructure, and
            social &amp; economic impact.
          </p>
        </ScrollAnimation>

        {/* Infographic */}
        <ScrollAnimation className={styles.imageWrap} delay={150}>
          <img
            src="/images/impact_infographic_v2.png"
            alt="Ten Wins, No Losses: The GreenScience Soil Revolution — an infographic showing ten environmental, community, and social benefits of the GreenScience process"
            className={styles.image}
          />
        </ScrollAnimation>

        {/* Win count strip */}
        <ScrollAnimation className={styles.pillStrip} delay={200}>
          {CATEGORIES.map((cat) => (
            <div key={cat.id} className={cn(styles.pill, styles[cat.colorClass])}>
              <span className={styles.pillCount}>{cat.count}</span>
              <span className={styles.pillLabel}>{cat.label}</span>
            </div>
          ))}
        </ScrollAnimation>

      </div>
    </section>
  );
}

const CATEGORIES = [
  {
    id: 'env',
    count: '4',
    label: 'Environmental Wins',
    colorClass: 'pillGreen',
  },
  {
    id: 'community',
    count: '3',
    label: 'Community & Infrastructure Wins',
    colorClass: 'pillBlue',
  },
  {
    id: 'social',
    count: '3',
    label: 'Social & Economic Wins',
    colorClass: 'pillOrange',
  },
];

export default ImpactInfographic;